import { styled } from "@ui/factory"

export const Text = styled("p")
